import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a68bc21a875aa001467d6e0_1787381349820_2bc40176/monezite/src/app/post-problem/page.tsx");
